import React from "react";
import { MenuItemLink } from "react-admin";
import LabelIcon from "@material-ui/icons/Label"; // import FTP from '../../Resources/FTP';
import PeopleIcon from "@material-ui/icons/People";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import User from "../../Resource/User";
import EventIcon from "@material-ui/icons/Event";

const MyMenu = (props) => {
  return (
    <div>
      <MenuItemLink
        key={User.name}
        to={`/User`}
        primaryText={"Users"}
        //   leftIcon={<Company.icon />}
        // onClick={onMenuClick}
        leftIcon={<PeopleIcon />}
      />
      <MenuItemLink
        // key={User.name}
        to={`/UserBadge`}
        primaryText={"Badges"}
        // leftIcon={<UserBadge.icon />}
        // onClick={onMenuClick}
        leftIcon={<LabelIcon />}
      />
      <MenuItemLink
        to={`/Offer`}
        primaryText={"Offers"}
        leftIcon={<LocalOfferIcon />}
      />

      <MenuItemLink
        // key={User.name}
        to={`/Appointment`}
        primaryText={"Appointments"}
        // leftIcon={<UserBadge.icon />}
        // onClick={onMenuClick}
        leftIcon={<EventIcon />}
      />

      {/* <MenuItemLink
              key={'Notification'}
              to={`/Notifications`}
              primaryText={"Notification"}
            //   leftIcon={<Company.icon />}
              onClick={onMenuClick}
              leftIcon={<NotificationsIcon/>}
        />
        <MenuItemLink
              key={Mentor.name}
              to={`/Mentor`}
              primaryText={"Mentor"}
            //   leftIcon={<Currency.icon />}
              onClick={onMenuClick}
              leftIcon={<PersonIcon/>}
            /> */}
      {/* <MenuItemLink
              key={'Mentee'}
              to={`/Mentee`}
              primaryText={"Mentee"}
            //   leftIcon={<Company.icon />}
              onClick={onMenuClick}
              leftIcon={<PeopleIcon/>}
        /> */}
      {/* <SubMenu
            key={'Reports'}
            handleToggle={() => handleToggle()}
            isOpen={menuMaster}
            sidebarIsOpen={open}
            name="Reports"
            icon={<LocalActivityIcon />}
          >
              {/* <MenuItemLink
              key={MentorList.name}
              to={`/MentorList`}
              primaryText={"Mentor List"}
            //   leftIcon={<Currency.icon />}
              onClick={onMenuClick}
              leftIcon={<ListIcon/>}
            /> */}

      {/* <MenuItemLink
        key={AppointmentList.name}
        to={`/Appointment`}
        primaryText={"Appointment List"}
        onClick={onMenuClick}
        leftIcon={<ListIcon />}
      />

      <MenuItemLink
        key={User.name}
        to={`/User?id=1`}
        primaryText={"User List"}
        leftIcon={<ListIcon />}
        onClick={onMenuClick}
      /> */}

      {/* <MenuItemLink
              key={FTPModule.name}
              to={`/FTPModule`}
              primaryText={"FTPModule"}
              leftIcon={<FTPModule.icon />}
              onClick={onMenuClick}
            /> */}

      {/* </SubMenu> */}
    </div>
  );
};

export default MyMenu;
